module.exports = __webpack_public_path__ + "static/img/8.d5fceb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/8.png
// module id = f0dy
// module chunks = 0